import * as i0 from "@angular/core";
var SaveTempService = /** @class */ (function () {
    function SaveTempService() {
        this.currentStorage = localStorage;
    }
    SaveTempService.prototype.getItem = function (key) {
        return JSON.parse(this.currentStorage.getItem(SaveTempService.prefix + key));
    };
    SaveTempService.prototype.setItem = function (key, data) {
        this.currentStorage.setItem(SaveTempService.prefix + key, JSON.stringify(data));
    };
    SaveTempService.prototype.empty = function () {
        var toRemove = [];
        var key;
        for (var i = 0; i < this.currentStorage.length; i++) {
            key = this.currentStorage.key(i);
            if (key && key.startsWith(SaveTempService.prefix)) {
                toRemove.push(key);
            }
        }
        for (var _i = 0, toRemove_1 = toRemove; _i < toRemove_1.length; _i++) {
            var key_1 = toRemove_1[_i];
            this.currentStorage.removeItem(key_1);
        }
    };
    SaveTempService.prefix = "save_temp_";
    SaveTempService.ngInjectableDef = i0.defineInjectable({ factory: function SaveTempService_Factory() { return new SaveTempService(); }, token: SaveTempService, providedIn: "root" });
    return SaveTempService;
}());
export { SaveTempService };
